// extracted by mini-css-extract-plugin
export default {"openBtn":"Menu_openBtn__o294u","menu":"Menu_menu__d7dQ8","list":"Menu_list__oD3cV"};